var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Row } from "react-bootstrap";
import styled from "styled-components";
import calculateHeightFromContent from "../utils/calculateHeightFromContent";
import Content from "./Content";
import { isRowEmpty } from "../utils/isRowEmpty";
var StyledRow = styled(function (_a) {
    var rowHeight = _a.rowHeight, rest = __rest(_a, ["rowHeight"]);
    return React.createElement(Row, __assign({}, rest));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  &:before,\n  &:after {\n    display: none;\n  }\n  min-height: ", ";\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  &:before,\n  &:after {\n    display: none;\n  }\n  min-height: ", ";\n"])), function (props) { return (props.rowHeight ? props.rowHeight + 30 + "px" : ""); });
var ContentColumns = function (_a) {
    var companyNewsRow = _a.companyNewsRow, pageView = _a.pageView;
    var isEmptyRow = isRowEmpty(companyNewsRow);
    return (React.createElement(StyledRow, { rowHeight: isEmptyRow ? calculateHeightFromContent(companyNewsRow) : undefined }, companyNewsRow.map(function (companyNewsTile, i) { return (React.createElement(Content, { companyNewsTile: companyNewsTile, key: i, pageView: pageView })); })));
};
export default ContentColumns;
var templateObject_1;
